
export default {
  name: 'payment',
  data: () => ({
    payment_types: []
  }),
  methods: {
    payment_type_cancel() {
      for (const index in this.computed_payment_types) {
        this.payment_types[index].status = this.computed_payment_types[index].status
      }
    },
    async payment_type_save() {
      this.update_loading = true
      if (this.$communicator.then(this, await this.$communicator('update_payment_types', {
        params: this.payment_types
      }))) {
        this.update_payment_types()
      }
      this.$toast.success("Success", { timeout: 2000 });
      this.update_loading = false
    },
    async update_payment_types() {
      const payment_types = this.$communicator.then(this, await this.$communicator('payment_types'))
      if (payment_types) {
        this.$store.commit('payment_types', this.$copy(payment_types))
        this.payment_types = this.$copy(payment_types)
        for (let i = 0; i < this.payment_types.length; i++) {
          this.payment_types[i].title = this.$t(this.payment_types[i].name)
        }
      }
    }
  },
  computed: {
    computed_payment_types() { return this.$store.state.payment_types }
  },
  mounted() {
    this.update_payment_types()
  }
}
